import { render, staticRenderFns } from "./RemoveDevice.vue?vue&type=template&id=105ff438&scoped=true"
import script from "./RemoveDevice.vue?vue&type=script&lang=ts"
export * from "./RemoveDevice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105ff438",
  null
  
)

export default component.exports